const RESEAU_TEMPO = {
  title: 'Planning réseaux temporaires',
  panier: 'Panier',
  myBrief: 'Mon brief',
  location: 'Location : {location}',
  afficherAnnonceur: 'Afficher les annonceurs',
  afficherLesOptions: 'Afficher les options',
  nePasReafficher: 'Ne pas réafficher',
  table: {
    libelle: 'Libellé',
    ville: 'Ville',
    societe: 'Société',
    agence: 'Agence',
  },
  action: {
    back: 'Retour',
    bloquer: 'Bloquer',
    option: 'Option',
    selection: 'Sélection',
    facesPrevus: 'Faces prévues',
    facesAffecteesAuReseau: 'Faces affectées au réseau',
  },
  legende: {
    title: 'Légende',
    bloqueCommande: 'Bloqué en commande',
    bloqueDevis: 'Bloqué en Devis',
    option: 'Option',
    facture: 'Facturé',
    libre: 'Libre',
    relanceOption: 'Relance d\'option',
  },
  brief: {
    errors: {
      produitLoc: 'Le produit de location est obligatoire',
      produitDefaultLoc: 'Aucun produit de location par défaut n\'est lié au réseau',
      errorProduitLocationNotFound: 'Aucune location trouvée dans la société',
      problemOccurred: 'Un problème est survenu',
      errorProduitCommande: 'Vous ne pouvez pas désélectionner ce produit, il a déjà été commandé',
    },
  },
  briefContent: {
    brief: 'Mon brief',
    appliquerBrief: 'Appliquer les paramètres de votre brief',
    location: 'Location',
    reseauConfrere: 'Inclure réseaux confrères',
    codeReseau: 'Code(s) réseau',
    libelle: 'Libellé(s)',
    type: 'Type(s) de réseau',
    villes: 'Ville(s) réseau',
    departements: 'Département',
    formats: 'Format',
    appliquer: 'Appliquer',
    reinitialiser: 'Réinitialiser',
    budgetMax: 'Budget max',
    societe: 'Société',
    locationDefault: 'Produit location par défaut',
    agence: 'Agence(s)',
  },
  panierContent: {
    panier: 'Panier',
    sousTitle: '{numberProduit} produits dans votre panier',
    panierVide: 'Votre panier est vide',
    total: 'Total',
    reseauPerso: 'Créer un réseau personnalisé',
    noProduct: 'Sélectionnez des produits',
    add: 'Ajouter',
    datePeriode: 'Du {dateDebut} au {dateFin} - S{semaine}',
    noNewProduct: 'Aucun produit ajouté via l\'écran de sélection',
    produitFromDCF: 'Produit(s) présent(s) dans {typeDCF}',
    newSelection: 'Nouvelle sélection',
    clearSelection: 'Vider ma sélection',
    type: {
      devis: 'le devis',
      commande: 'la commande',
      facture: 'la facture',
    },
    etatSouhaiteObtenu: 'Etat souhaité: {etatSouhaite} - Etat obtenu: {etatObtenu}',
    actions: {
      creerCommande: 'Créer une commande',
      creerDevis: 'Créer un devis',
    },
    errors: {
      commandeWithOption: 'Vous ne pouvez pas créer de commande si vous avez sélectionné des réseaux temporaires avec un état souhaité à \'Option\'',
    },
  },
  produit: 'Produit',
  montant: 'Montant',
  nc: 'nc.',
};

export default RESEAU_TEMPO;
